module.exports = __webpack_public_path__ + "school/img/signup_form_btn.905bbe97.png";